import { ReactComponent as DashBoardIcon } from '../assets/img/dashboard-icon.svg';
import { ReactComponent as InventoryIcon } from '../assets/img/inventory-icon.svg';
import { ReactComponent as Inventory2Icon } from '../assets/img/inventory2.svg';
import { ReactComponent as UserManagementIcon } from '../assets/img/usermgmt.svg';
interface UrlLink {
  id: string;
  label?: string;
  url?: string;
  isSubLinks?: boolean;
  sublinks?: Array<UrlLink>;
  shouldOpenNewTab?: boolean;
  isActive?: boolean;
}

export interface NavLink extends UrlLink {
  icon?: React.ReactNode;
  navigate?: () => void;
}

const _dashboardLinks = (select: any) => {
  return [
    {
      id: 'dashboard',
      icon: <DashBoardIcon stroke={select === 'dashboard' ? 'white' : 'black'} />,
      label: 'Dashboard',
      url: '/dashboard',
    },
    {
      id: 'inventory1',
      icon: <InventoryIcon stroke={select === 'inventory1' ? 'white' : 'black'} />,
      label: 'Inventory-1',
      url: '/inventory1',
    },
    {
      id: 'inventory2',
      icon: <Inventory2Icon stroke={select === 'inventory2' ? 'white' : 'black'} />,
      label: 'Inventory-2',
      url: '/inventory2',
    },
    // {
    //   id: 'user-management',
    //   icon: <UserManagementIcon stroke={select === 'user-management' ? 'white' : 'black'} />,
    //   label: 'User Management',
    //   url: '/user-management',
    // },
  ];
}

export default _dashboardLinks;
